'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup.jsx';

import Headers from './Headers.jsx';
import Table from './Table.jsx';

class ListaDeUsuarios extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getData(this.props.executionContext, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStateListUser();
    }

    render() {
        let component = null;
        let spinner = <div className="loading">Loading&#8230;</div>;

        if (this.props.data.isFetching == true)
            return spinner;

        if (this.props.data.functions != undefined) {
            let functions = this.props.data.functions;

            if (functions.Consulta == true) {
                component = (
                    <div>
                        <div className="container-fluid concierge">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1>Usuarios</h1>
                                </div>
                            </div>

                            <Headers
                                functions={this.props.data.functions}
                                usuarios={this.props.data.usuarios}
                                searchUser={this.props.searchUser}
                                usuariosFiltrados={this.props.data.usuariosFiltrados}
                                setActivosCheckbox={this.props.setActivosCheckbox}
                                setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                                setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                                setMotivoBloqueo={this.props.setMotivoBloqueo}
                                setUserState={this.props.setUserState}
                                data={this.props.data}
                            />

                            <Table
                                functions={this.props.data.functions}
                                currentUser={this.props.data.currentUser}
                                usuarios={this.props.data.usuarios}
                                usuariosFiltrados={this.props.data.usuariosFiltrados}
                                columnIndex={this.props.data.columnIndex}
                                column={this.props.data.column}
                                orderColumn={this.props.orderColumn}
                                setAllCheckbox={this.props.setAllCheckbox}
                                allCheckboxFilter={this.props.data.allCheckboxFilter}
                                setCheckbox={this.props.setCheckbox}
                                setUserState={this.props.setUserState}
                            />
                        </div>
                    </div>
                );
            } else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                component = <GenericErrorScreen data={values} />;
            }

            return (component);
        } else {
            return spinner;
        }
    }
}

export default ListaDeUsuarios;